var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('article',{staticClass:"con4"},[_c('div',{staticClass:"inner container"},[_c('p',[_vm._v("지원문의")]),_c('ul',[_c('li',[_vm._v("㈜캐럿글로벌 HR팀")]),_c('li',[_vm._v("TEL : (02)518-5468")]),_c('li',[_vm._v("E-mail : recruit@carrotglobal.com")]),_c('li',[_vm._v("주소 : 서울특별시 서초구 강남대로 479 신논현타워 6F")])])])])])
}]

export { render, staticRenderFns }